import React, { useEffect } from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import { Link } from "react-router-dom";
import {
    AiOutlineArrowLeft,
    AiOutlineArrowRight,
    AiOutlineShareAlt,
  } from "react-icons/ai";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

  const izbNewsSlider1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public-1.jpg";  

  const izbNewsSlider2 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo-Zambia-Bank-to-Fund-Prospective-Home-1.jpg";  

  const izbNewsSlider3 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/INDO-ZAMBIA-BANK-AND-ZAMBIA-AIR-FORCE.jpg";

  const izbNewsSlider4 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-agreement-frontclear.png";

  const izbNewsSlider5 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo-Zambia-Bank-COP29.png";

  const izbNewsSlider6 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB@40-1.jpg";

  const izbNewsSlider7 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/celebrating-zambia-s-diamond-jubilee-of-independence-1.jpg";

  const izbNewsSlider8 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-partners-with-action-new-mod-4.jpg";

  const izbNewsSlider9 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/zambia-financial-literacy-week-2025.png";

  const izbNewsSlider10 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-40th-annual-general-meeting-5.png";

  const izbNewsSlider11 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-3.jpg";

  const izbNewsSlider12 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz-4.jpeg"

  const izbNewsSlider13 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024-banner-1.png"

  const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";

  const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

const LatestNews = () => {
const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/BackgroundBrundcrumb.png";
const career = "https://izbassetsmain.blob.core.windows.net/izbwebassets/EMPLOYMENT AND CAREER DEVELOPMENT OPPORTUNITIES-Thumbnail.png";
const customerNotice ="https://izbassetsmain.blob.core.windows.net/izbwebassets/Thumbnail-Customer Notice.png";
const customerNotice1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Customer_Notice_1-thumbnail.png";
useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowLeft}
      className={className}
      style={{
        ...style,
        display: "block",
        width: "50px",
        height: "50px",
        left: "-58px",
        zIndex:"99"
      }}
      onClick={onClick}
    />
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowRight}
      className={className}
 
      onClick={onClick}
    />
  );
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}; 


  return (
    <>
      <Breadcrumb Heading="Latest News" img={BackgroundBrundcrumb} />

      <section className="latest-news pb-4 news-slider-sub">
            <div className="container">
              <div className="row">
                <div className="container">
                  <div className="heading py-3">
                    <h1 className="text-center pt-4">Latest News</h1>
                    <p className="text-center pb-4">All News And Updates</p>
                  </div>
               
                </div>

                <div className="col-xl-4 col-lg-6 hide-on-tablet">
                                            <div
                                              className="single-blog-style1 wow fadeInUp"
                                              data-wow-delay="00ms"
                                              data-wow-duration="1500ms"
                                            >
                                            <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024">
                                              <div className="img-holder">
                                                <div className="inner">
                                                  <img className="imgresize" src={izbNewsSlider13} alt="" />
                                            
                                                    <div className="overlay-icon"></div>
                                                
                                                </div>
                                              </div>
                                              </a>
                                                <div className="text-holder">
                                                <h3 className="blog-title mt-0 text-left">
                                                <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024" style={{textTransform: "none"}}>
                                                    Indo Zambia Bank is proud to be awarded Best Customer...
                                                </a><br/>
                                                    <span style={{ fontSize: "15px", color: "gray" }}>May 13, 2025</span>
                                                </h3>
                                                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                                                    This past Friday, we were honoured to attend the 28th Annual Zambia Institute of Marketing Excellence Conference and Awards Gala Dinner held in Livingstone. At the same event, Indo Zambia Bank was awarded...
                                                </p>
                                                <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024">
                                                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                                                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                                                    </h5>
                                                </a>
                                                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                                                </div>
                                            </div>
                </div>

                <div className="col-xl-4 col-lg-6 hide-on-tablet">
                                            <div
                                              className="single-blog-style1 wow fadeInUp"
                                              data-wow-delay="00ms"
                                              data-wow-duration="1500ms"
                                            >
                                            <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz">
                                              <div className="img-holder">
                                                <div className="inner">
                                                  <img className="imgresize" src={izbNewsSlider12} alt="" />
                                            
                                                    <div className="overlay-icon"></div>
                                                
                                                </div>
                                              </div>
                                              </a>
                                                <div className="text-holder">
                                                <h3 className="blog-title mt-0 text-left">
                                                <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz" style={{textTransform: "none"}}>
                                                    Indo Zambia Bank Signs a (MoU) with the (DAZ)
                                                </a><br/>
                                                    <span style={{ fontSize: "15px", color: "gray" }}>April 23, 2025</span>
                                                </h3>
                                                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                                                    Indo Zambia Bank is pleased to announce the signing of a Memorandum of Understanding (MoU) with the Dairy Association of Zambia (DAZ) for the provision of loan facilities to its members. Through this....
                                                </p>
                                                <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz">
                                                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                                                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                                                    </h5>
                                                </a>
                                                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                                                </div>
                                            </div>
                </div>

                <div className="col-xl-4 col-lg-6 hide-on-tablet">
                                            <div
                                              className="single-blog-style1 wow fadeInUp"
                                              data-wow-delay="00ms"
                                              data-wow-duration="1500ms"
                                            >
                                            <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                                              <div className="img-holder">
                                                <div className="inner">
                                                  <img className="imgresize" src={izbNewsSlider11} alt="" />
                                            
                                                    <div className="overlay-icon"></div>
                                                
                                                </div>
                                              </div>
                                              </a>
                                                <div className="text-holder">
                                                <h3 className="blog-title mt-0 text-left">
                                                <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                                                    Coffee & Cars with Indo Zambia Bank, in partnership...
                                                </a><br/>
                                                    <span style={{ fontSize: "15px", color: "gray" }}>April 14, 2025</span>
                                                </h3>
                                                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                                                    This past weekend we partnered with Southern Cross Motors for an unforgettable Coffee & Cars experience! Guests had the unique opportunity to test drive some of the world’s finest motor vehicle brands...
                                                </p>
                                                <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                                                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                                                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                                                    </h5>
                                                </a>
                                                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                                                </div>
                                            </div>
                </div>

                <div className="col-xl-4 col-lg-6 hide-on-tablet">
                                            <div
                                              className="single-blog-style1 wow fadeInUp"
                                              data-wow-delay="00ms"
                                              data-wow-duration="1500ms"
                                            >
                                            <a href="https://www.youtube.com/watch?v=WFhRVyp-Z2U" target="_blank">
                                              <div className="img-holder">
                                                <div className="inner">
                                                  <img className="imgresize" src={izbNewsSlider9} alt="" />
                                            
                                                    <div className="overlay-icon"></div>
                                                
                                                </div>
                                              </div>
                                              </a>
                                                <div className="text-holder">
                                                <h3 className="blog-title mt-0 text-left">
                                                <a href="https://www.youtube.com/watch?v=WFhRVyp-Z2U" target="_blank">
                                                      Zambia Financial Literacy Week 2025
                                                </a><br/>
                                                    <span style={{ fontSize: "15px", color: "gray" }}>April 01, 2025</span>
                                                </h3>
                                                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                                                This year, we took financial literacy beyond banking, reaching communities across all 10 provinces of Zambia.
                                                At Indo Zambia Bank, we believe that financial literacy is the key to a brighter future.
                                                </p>
                                                <a href="https://www.youtube.com/watch?v=WFhRVyp-Z2U" target="_blank">
                                                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                                                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                                                    </h5>
                                                </a>
                                                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                                                </div>
                                            </div>
                </div>

                <div className="col-xl-4 col-lg-6 hide-on-tablet">
                                            <div
                                              className="single-blog-style1 wow fadeInUp"
                                              data-wow-delay="00ms"
                                              data-wow-duration="1500ms"
                                            >
                                             <a href="/izb-40th-annual-general-meeting">
                                              <div className="img-holder">
                                                <div className="inner">
                                                  <img className="imgresize" src={izbNewsSlider10} alt="" />
                                            
                                                    <div className="overlay-icon"></div>
                                                
                                                </div>
                                              </div>
                                              </a>
                                                <div className="text-holder">
                                                <h3 className="blog-title mt-0 text-left">
                                                <a href="/izb-40th-annual-general-meeting">
                                                    IZB 40th Annual General Meeting
                                                </a><br/>
                                                    <span style={{ fontSize: "15px", color: "gray" }}>April 01, 2025</span>
                                                </h3>
                                                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                                                Last Friday, the bank held its 40th Annual General Meeting, followed by a press briefing where our Board Chairman, Dr. Michael Gondwe, shared highlights of the Bank’s 2024 financial performance...
                                                </p>
                                                <a href="/izb-40th-annual-general-meeting">
                                                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                                                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                                                    </h5>
                                                </a>
                                                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                                                </div>
                                            </div>
                </div>
            
                <div className="col-xl-4 col-lg-6 hide-on-tablet">
                                            <div
                                              className="single-blog-style1 wow fadeInUp"
                                              data-wow-delay="00ms"
                                              data-wow-duration="1500ms"
                                            >
                                            <a href="/indo-zambia-bank-partners-with-action-auto-zambia-to-extend-vehicle-financing-options">
                                              <div className="img-holder">
                                                <div className="inner">
                                                  <img className="imgresize" src={izbNewsSlider8} alt="" />
                                            
                                                    <div className="overlay-icon"></div>
                                                
                                                </div>
                                              </div>
                                              </a>
                                                <div className="text-holder">
                                                <h3 className="blog-title mt-0 text-left">
                                                    <a href="/indo-zambia-bank-partners-with-action-auto-zambia-to-extend-vehicle-financing-options">
                                                      Indo Zambia Bank Partners with Action Auto...
                                                </a><br/>
                                                    <span style={{ fontSize: "15px", color: "gray" }}>March 03, 2025</span>
                                                </h3>
                                                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                                                Indo Zambia Bank is pleased to announce a strategic partnership with Action Auto Zambia Limited, an authorized Isuzu vehicles dealer. This collaboration extends the Indo Vehicle Finance program to the general...
                                                </p>
                                                <a href="/indo-zambia-bank-partners-with-action-auto-zambia-to-extend-vehicle-financing-options">
                                                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                                                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                                                    </h5>
                                                </a>
                                                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                                                </div>
                                            </div>
                </div>

                <div className="col-xl-4 col-lg-6 hide-on-tablet">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                  <a href="/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public">
                    <div className="img-holder">
                      <div className="inner">
                        <img className="imgresize" src={izbNewsSlider1} alt="" />
                  
                          <div className="overlay-icon"></div>
                      
                      </div>
                    </div>
                    </a>
                      <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                          <a href="/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public">
                            Indo Zambia Bank And Southern Cross Motors...
                      </a><br/>
                          <span style={{ fontSize: "15px", color: "gray" }}>Jan 29, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                  
                      Indo Zambia Bank has partnered with @southerncrossmotors to provide motor vehicle financing to the general public through a Memorandum of Understanding signed yesterday...
                      </p>
                      <a href="/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public">
                          <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                          </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                      </div>
                  </div>
                </div>
      
                <div className="col-xl-4 col-lg-6 hide-on-tablet">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                  <a href="/indo-zambia-bank-to-fund-prospective-home-owners-in-the-hills-property-development">
                    <div className="img-holder">
                      <div className="inner">
                        <img className="imgresize" src={izbNewsSlider2} alt="" />
                  
                          <div className="overlay-icon"></div>
                      
                      </div>
                    </div>
                    </a>
                      <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                          <a href="/indo-zambia-bank-to-fund-prospective-home-owners-in-the-hills-property-development">
                            Indo Zambia Bank To Fund Prospective Home...
                          </a><br/>
                          <span style={{ fontSize: "15px", color: "gray" }}>Jan 27, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                      On 20th January 2025, Indo Zambia Bank (IZB) signed a memorandum of understanding with The Hills Property Development to revolutionise homeownership opportunities in zambia. Through this...
                      </p>
                      <a href="/indo-zambia-bank-to-fund-prospective-home-owners-in-the-hills-property-development">
                          <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                          </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                      </div>
                  </div>
                </div>
      
                <div className="col-xl-4 col-lg-6 hide-on-tablet">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                  <a href="/indo-zambia-bank-and-zambia-air-force-forging-stronger-partnerships">
                    <div className="img-holder">
                      <div className="inner">
                        <img className="imgresize" src={izbNewsSlider3} alt="" />
                  
                          <div className="overlay-icon"></div>
                      
                      </div>
                    </div>
                    </a>
                      <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                          <a href="/indo-zambia-bank-and-zambia-air-force-forging-stronger-partnerships">
                          Indo Zambia Bank And Zambia Air Force...
                      </a><br/>
                          <span style={{ fontSize: "15px", color: "gray" }}>Jan 21, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                
                        On 20th January 2025, Indo Zambia Bank Managing Director, Mr. Brajesh Kumar Singh accompanied by the General Manager Mr. Godwin C. Ngoma and his delegation...
                      </p>
                      <a href="/indo-zambia-bank-and-zambia-air-force-forging-stronger-partnerships">
                          <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                          </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                      </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-6 hide-on-tablet">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                  <a href="/indo-zambia-bank-has-signed-an-agreement-with-frontclear">
                    <div className="img-holder">
                      <div className="inner">
                        <img className="imgresize" src={izbNewsSlider4} alt="" />
                  
                          <div className="overlay-icon"></div>
                      
                      </div>
                    </div>
                    </a>
                      <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                          <a href="/indo-zambia-bank-has-signed-an-agreement-with-frontclear">
                          Indo Zambia Bank has signed an agreement...
                      </a><br/>
                          <span style={{ fontSize: "15px", color: "gray" }}>November 29, 2024</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Recognizing that Money Markets are central to the functioning of financial systems, Indo Zambia Bank has signed an agreement with Frontclear enabling the Bank to participate...
                      </p>
                      <a href="/indo-zambia-bank-has-signed-an-agreement-with-frontclear">
                          <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                          </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                      </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-6 hide-on-tablet">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                  <a href="/indo-zambia-bank-is-here-at-cop29">
                    <div className="img-holder">
                      <div className="inner">
                        <img className="imgresize" src={izbNewsSlider5} alt="" />
                  
                          <div className="overlay-icon"></div>
                      
                      </div>
                    </div>
                    </a>
                      <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                          <a href="/indo-zambia-bank-is-here-at-cop29">
                          Indo Zambia Bank is here at COP29!
                      </a><br/>
                          <span style={{ fontSize: "15px", color: "gray" }}>November 13, 2024</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank was proud to attend the COP29 UN Climate Change Conference in Baku, Azerbaijan. Staying at the forefront of climate action, we are committed to innovative ...
                      </p>
                      <a href="/indo-zambia-bank-is-here-at-cop29">
                          <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                          </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                      </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-6 hide-on-tablet">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                  <a href="/celebrating-zambia-s-diamond-jubilee-of-independence">
                    <div className="img-holder">
                      <div className="inner">
                        <img className="imgresize" src={izbNewsSlider7} alt="" />
                  
                          <div className="overlay-icon"></div>
                      
                      </div>
                    </div>
                    </a>
                      <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                          <a href="/celebrating-zambia-s-diamond-jubilee-of-independence">
                          Celebrating Zambia’s Diamond Jubilee of Independence!
                      </a><br/>
                          <span style={{ fontSize: "15px", color: "gray" }}>November 7, 2024</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        In honor of Zambia’s 60th Independence Day, our Chipata Branch proudly donated brand-new beddings to Kapata Urban Clinic, bringing comfort to patients and supporting quality...
                      </p>
                      <a href="/celebrating-zambia-s-diamond-jubilee-of-independence">
                          <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                          </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                      </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-6 hide-on-tablet">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                  <a href="/izb-40-creativity-unleashed">
                    <div className="img-holder">
                      <div className="inner">
                        <img className="imgresize" src={izbNewsSlider6} alt="" />
                  
                          <div className="overlay-icon"></div>
                      
                      </div>
                    </div>
                    </a>
                      <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                          <a href="/izb-40-creativity-unleashed">
                          IZB@40: CREATIVITY UNLEASHED
                      </a><br/>
                          <span style={{ fontSize: "15px", color: "gray" }}>October 2, 2024</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        We are thrilled to announce the winners of the IZB@40: CREATIVITY UNLEASHED social media competition held in partnership with the National Arts Council of Zambia. A big...
                      </p>
                      <a href="/izb-40-creativity-unleashed">
                          <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                          </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                      </div>
                  </div>
                </div>



                <div className="test show-on-tablet news-slider-list-slider row align-items-center">
                  <Slider {...settings}>

                    <div className="col-xl-4 col-lg-4">
                      <div
                        className="single-blog-style1 wow fadeInUp"
                        data-wow-delay="00ms"
                        data-wow-duration="1500ms"
                      >
                        <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024">
                          <div className="img-holder">
                            <div className="inner">
                              <img className="imgresize" src={izbNewsSlider13} alt="" />
                        
                                <div className="overlay-icon"></div>
                            
                            </div>
                          </div>
                        </a>
                          <div className="text-holder">
                          <h3 className="blog-title mt-0 text-left">
                          <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024">
                              Indo Zambia Bank is proud to be awarded Best Customer...
                          </a><br/>
                              <span style={{ fontSize: "15px", color: "gray" }}>May 13, 2025</span>
                          </h3>
                          <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                               This past Friday, we were honoured to attend the 28th Annual Zambia Institute of Marketing Excellence Conference and Awards Gala Dinner held in Livingstone. At the same event, Indo Zambia Bank was awarded...
                          </p>
                          <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024">
                              <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                              Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                              </h5>
                          </a>
                          <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                          </div>
                      </div>
                    </div>

                    <div className="col-xl-4 col-lg-4">
                      <div
                        className="single-blog-style1 wow fadeInUp"
                        data-wow-delay="00ms"
                        data-wow-duration="1500ms"
                      >
                        <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz">
                          <div className="img-holder">
                            <div className="inner">
                              <img className="imgresize" src={izbNewsSlider12} alt="" />
                        
                                <div className="overlay-icon"></div>
                            
                            </div>
                          </div>
                        </a>
                          <div className="text-holder">
                          <h3 className="blog-title mt-0 text-left">
                          <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz">
                              Indo Zambia Bank Signs a (MoU) with the (DAZ)
                          </a><br/>
                              <span style={{ fontSize: "15px", color: "gray" }}>April 23, 2025</span>
                          </h3>
                          <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                              Indo Zambia Bank is pleased to announce the signing of a Memorandum of Understanding (MoU) with the Dairy Association of Zambia (DAZ) for the provision of loan facilities to its members. Through this....
                          </p>
                          <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz">
                              <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                              Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                              </h5>
                          </a>
                          <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                          </div>
                      </div>
                    </div>

                    <div className="col-xl-4 col-lg-4">
                      <div
                        className="single-blog-style1 wow fadeInUp"
                        data-wow-delay="00ms"
                        data-wow-duration="1500ms"
                      >
                        <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                          <div className="img-holder">
                            <div className="inner">
                              <img className="imgresize" src={izbNewsSlider11} alt="" />
                        
                                <div className="overlay-icon"></div>
                            
                            </div>
                          </div>
                        </a>
                          <div className="text-holder">
                          <h3 className="blog-title mt-0 text-left">
                          <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                              Coffee & Cars with Indo Zambia Bank, in partnership...
                          </a><br/>
                              <span style={{ fontSize: "15px", color: "gray" }}>April 14, 2025</span>
                          </h3>
                          <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                              This past weekend we partnered with Southern Cross Motors for an unforgettable Coffee & Cars experience! Guests had the unique opportunity to test drive some of the world’s finest motor vehicle brands...
                          </p>
                          <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                              <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                              Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                              </h5>
                          </a>
                          <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                          </div>
                      </div>
                    </div>

                    <div className="col-xl-4 col-lg-4">
                      <div
                        className="single-blog-style1 wow fadeInUp"
                        data-wow-delay="00ms"
                        data-wow-duration="1500ms"
                      >
                        <a href="https://www.youtube.com/watch?v=WFhRVyp-Z2U" target="_blank">
                          <div className="img-holder">
                            <div className="inner">
                              <img className="imgresize" src={izbNewsSlider9} alt="" />
                        
                                <div className="overlay-icon"></div>
                            
                            </div>
                          </div>
                        </a>
                          <div className="text-holder">
                          <h3 className="blog-title mt-0 text-left">
                          <a href="https://www.youtube.com/watch?v=WFhRVyp-Z2U" target="_blank">
                              Zambia Financial Literacy Week 2025
                          </a><br/>
                              <span style={{ fontSize: "15px", color: "gray" }}>April 01, 2025</span>
                          </h3>
                          <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                      
                            This year, we took financial literacy beyond banking, reaching communities across all 10 provinces of Zambia.
                            At Indo Zambia Bank, we believe that financial literacy is the key to a brighter future.
                          </p>
                          <a href="https://www.youtube.com/watch?v=WFhRVyp-Z2U" target="_blank">
                              <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                              Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                              </h5>
                          </a>
                          <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                          </div>
                      </div>
                    </div>

                    <div className="col-xl-4 col-lg-4">
                      <div
                        className="single-blog-style1 wow fadeInUp"
                        data-wow-delay="00ms"
                        data-wow-duration="1500ms"
                      >
                      <a href="/izb-40th-annual-general-meeting">
                        <div className="img-holder">
                          <div className="inner">
                            <img className="imgresize" src={izbNewsSlider10} alt="" />
                      
                              <div className="overlay-icon"></div>
                          
                          </div>
                        </div>
                        </a>
                          <div className="text-holder">
                          <h3 className="blog-title mt-0 text-left">
                          <a href="/izb-40th-annual-general-meeting">
                              IZB 40th Annual General Meeting
                          </a><br/>
                              <span style={{ fontSize: "15px", color: "gray" }}>April 01, 2025</span>
                          </h3>
                          <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                      
                          Last Friday, the bank held its 40th Annual General Meeting, followed by a press briefing where our Board Chairman, Dr. Michael Gondwe, shared highlights of the Bank’s 2024 financial performance...
                          </p>
                          <a href="/izb-40th-annual-general-meeting">
                              <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                              Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                              </h5>
                          </a>
                          <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                          </div>
                      </div>
                    </div>

                    <div className="col-xl-4 col-lg-4">
                      <div
                        className="single-blog-style1 wow fadeInUp"
                        data-wow-delay="00ms"
                        data-wow-duration="1500ms"
                      >
                      <a href="/indo-zambia-bank-partners-with-action-auto-zambia-to-extend-vehicle-financing-options">
                        <div className="img-holder">
                          <div className="inner">
                            <img className="imgresize" src={izbNewsSlider8} alt="" />
                      
                              <div className="overlay-icon"></div>
                          
                          </div>
                        </div>
                        </a>
                          <div className="text-holder">
                          <h3 className="blog-title mt-0 text-left">
                              <a href="/indo-zambia-bank-partners-with-action-auto-zambia-to-extend-vehicle-financing-options">
                              Indo Zambia Bank Partners with Action Auto...
                          </a><br/>
                              <span style={{ fontSize: "15px", color: "gray" }}>March 03, 2025</span>
                          </h3>
                          <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                      
                          Indo Zambia Bank is pleased to announce a strategic partnership with Action Auto Zambia Limited, an authorized Isuzu vehicles dealer. This collaboration extends the Indo Vehicle Finance program to the general...
                          </p>
                          <a href="/indo-zambia-bank-partners-with-action-auto-zambia-to-extend-vehicle-financing-options">
                              <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                              Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                              </h5>
                          </a>
                          <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                          </div>
                      </div>
                    </div>

                    <div className="col-xl-4 col-lg-4">
                      <div
                        className="single-blog-style1 wow fadeInUp"
                        data-wow-delay="00ms"
                        data-wow-duration="1500ms"
                      >
                      <a href="/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public">
                        <div className="img-holder">
                          <div className="inner">
                            <img className="imgresize" src={izbNewsSlider1} alt="" />
                      
                              <div className="overlay-icon"></div>
                          
                          </div>
                        </div>
                        </a>
                          <div className="text-holder">
                          <h3 className="blog-title mt-0 text-left">
                              <a href="/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public">
                                Indo Zambia Bank And Southern Cross Motors...
                          </a><br/>
                              <span style={{ fontSize: "15px", color: "gray" }}>Jan 29, 2025</span>
                          </h3>
                          <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                      
                          Indo Zambia Bank has partnered with @southerncrossmotors to provide motor vehicle financing to the general public through a Memorandum of Understanding signed yesterday...
                          </p>
                          <a href="/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public">
                              <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                              Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                              </h5>
                          </a>
                          <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                          </div>
                      </div>
                    </div>
      
                    <div className="col-xl-4 col-lg-4">
                      <div
                        className="single-blog-style1 wow fadeInUp"
                        data-wow-delay="00ms"
                        data-wow-duration="1500ms"
                      >
                      <a href="/indo-zambia-bank-to-fund-prospective-home-owners-in-the-hills-property-development">
                        <div className="img-holder">
                          <div className="inner">
                            <img className="imgresize" src={izbNewsSlider2} alt="" />
                      
                              <div className="overlay-icon"></div>
                          
                          </div>
                        </div>
                        </a>
                          <div className="text-holder">
                          <h3 className="blog-title mt-0 text-left">
                              <a href="/indo-zambia-bank-to-fund-prospective-home-owners-in-the-hills-property-development">
                                Indo Zambia Bank To Fund Prospective Home...
                              </a><br/>
                              <span style={{ fontSize: "15px", color: "gray" }}>Jan 27, 2025</span>
                          </h3>
                          <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                          On 20th January 2025, Indo Zambia Bank (IZB) signed a memorandum of understanding with The Hills Property Development to revolutionise homeownership opportunities in zambia. Through this...
                          </p>
                          <a href="/indo-zambia-bank-to-fund-prospective-home-owners-in-the-hills-property-development">
                              <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                              Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                              </h5>
                          </a>
                          <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                          </div>
                      </div>
                    </div>
          
                    <div className="col-xl-4 col-lg-4">
                      <div
                        className="single-blog-style1 wow fadeInUp"
                        data-wow-delay="00ms"
                        data-wow-duration="1500ms"
                      >
                      <a href="/indo-zambia-bank-and-zambia-air-force-forging-stronger-partnerships">
                        <div className="img-holder">
                          <div className="inner">
                            <img className="imgresize" src={izbNewsSlider3} alt="" />
                      
                              <div className="overlay-icon"></div>
                          
                          </div>
                        </div>
                        </a>
                          <div className="text-holder">
                          <h3 className="blog-title mt-0 text-left">
                              <a href="/indo-zambia-bank-and-zambia-air-force-forging-stronger-partnerships">
                              Indo Zambia Bank And Zambia Air Force...
                          </a><br/>
                              <span style={{ fontSize: "15px", color: "gray" }}>Jan 21, 2025</span>
                          </h3>
                          <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    
                            On 20th January 2025, Indo Zambia Bank Managing Director, Mr. Brajesh Kumar Singh accompanied by the General Manager Mr. Godwin C. Ngoma and his delegation, paid a courtesy ...
                          </p>
                          <a href="/indo-zambia-bank-and-zambia-air-force-forging-stronger-partnerships">
                              <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                              Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                              </h5>
                          </a>
                          <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                          </div>
                      </div>
                    </div>

                    <div className="col-xl-4 col-lg-4">
                      <div
                        className="single-blog-style1 wow fadeInUp"
                        data-wow-delay="00ms"
                        data-wow-duration="1500ms"
                      >
                      <a href="/indo-zambia-bank-has-signed-an-agreement-with-frontclear">
                        <div className="img-holder">
                          <div className="inner">
                            <img className="imgresize" src={izbNewsSlider4} alt="" />
                      
                              <div className="overlay-icon"></div>
                          
                          </div>
                        </div>
                        </a>
                          <div className="text-holder">
                          <h3 className="blog-title mt-0 text-left">
                              <a href="/indo-zambia-bank-has-signed-an-agreement-with-frontclear">
                              Indo Zambia Bank has signed an agreement...
                          </a><br/>
                              <span style={{ fontSize: "15px", color: "gray" }}>November 29, 2024</span>
                          </h3>
                          <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                            Recognizing that Money Markets are central to the functioning of financial systems, Indo Zambia Bank has signed an agreement with Frontclear enabling the Bank to participate...
                          </p>
                          <a href="/indo-zambia-bank-has-signed-an-agreement-with-frontclear">
                              <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                              Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                              </h5>
                          </a>
                          <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                          </div>
                      </div>
                    </div>

                    <div className="col-xl-4 col-lg-4">
                      <div
                        className="single-blog-style1 wow fadeInUp"
                        data-wow-delay="00ms"
                        data-wow-duration="1500ms"
                      >
                      <a href="/izb-40-creativity-unleashed">
                        <div className="img-holder">
                          <div className="inner">
                            <img className="imgresize" src={izbNewsSlider6} alt="" />
                      
                              <div className="overlay-icon"></div>
                          
                          </div>
                        </div>
                        </a>
                          <div className="text-holder">
                          <h3 className="blog-title mt-0 text-left">
                              <a href="/izb-40-creativity-unleashed">
                              IZB@40: CREATIVITY UNLEASHED
                          </a><br/>
                              <span style={{ fontSize: "15px", color: "gray" }}>October 2, 2024</span>
                          </h3>
                          <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                            We are thrilled to announce the winners of the IZB@40: CREATIVITY UNLEASHED social media competition held in partnership with the National Arts Council of Zambia. A big...
                          </p>
                          <a href="/izb-40-creativity-unleashed">
                              <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                              Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                              </h5>
                          </a>
                          <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                          </div>
                      </div>
                    </div>

                    <div className="col-xl-4 col-lg-4">
                      <div
                        className="single-blog-style1 wow fadeInUp"
                        data-wow-delay="00ms"
                        data-wow-duration="1500ms"
                      >
                      <a href="/celebrating-zambia-s-diamond-jubilee-of-independence">
                        <div className="img-holder">
                          <div className="inner">
                            <img className="imgresize" src={izbNewsSlider7} alt="" />
                      
                              <div className="overlay-icon"></div>
                          
                          </div>
                        </div>
                        </a>
                          <div className="text-holder">
                          <h3 className="blog-title mt-0 text-left">
                              <a href="/celebrating-zambia-s-diamond-jubilee-of-independence">
                              Celebrating Zambia’s Diamond Jubilee of Independence!
                          </a><br/>
                              <span style={{ fontSize: "15px", color: "gray" }}>November 7, 2024</span>
                          </h3>
                          <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                            In honor of Zambia’s 60th Independence Day, our Chipata Branch proudly donated brand-new beddings to Kapata Urban Clinic, bringing comfort to patients and supporting quality...
                          </p>
                          <a href="/celebrating-zambia-s-diamond-jubilee-of-independence">
                              <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                              Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                              </h5>
                          </a>
                          <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                          </div>
                      </div>
                    </div>

                    <div className="col-xl-4 col-lg-4">
                      <div
                        className="single-blog-style1 wow fadeInUp"
                        data-wow-delay="00ms"
                        data-wow-duration="1500ms"
                      >
                      <a href="/indo-zambia-bank-is-here-at-cop29">
                        <div className="img-holder">
                          <div className="inner">
                            <img className="imgresize" src={izbNewsSlider5} alt="" />
                      
                              <div className="overlay-icon"></div>
                          
                          </div>
                        </div>
                        </a>
                          <div className="text-holder">
                          <h3 className="blog-title mt-0 text-left">
                              <a href="/indo-zambia-bank-is-here-at-cop29">
                              Indo Zambia Bank is here at COP29!
                          </a><br/>
                              <span style={{ fontSize: "15px", color: "gray" }}>November 13, 2024</span>
                          </h3>
                          <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                            Indo Zambia Bank was proud to attend the COP29 UN Climate Change Conference in Baku, Azerbaijan. Staying at the forefront of climate action, we are committed to innovative ...
                          </p>
                          <a href="/indo-zambia-bank-is-here-at-cop29">
                              <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                              Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                              </h5>
                          </a>
                          <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                          </div>
                      </div>
                    </div>
                  </Slider>
                </div>
                
              </div>
            </div>
       </section>

      <div className="col-xl-12 justify-content-center"></div>
      <AllAcountsSection />
    </>
  );
};

export default LatestNews;
